"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns a list of CatalogItems (the display entity) matching the provided array list
 *
 * @param itemArray - An array of general catalog items to map
 * @param valueKey - The value that will be used as 'Value'
 */
function mapToCatalogItem(itemArray, valueKey) {
    if (valueKey === void 0) { valueKey = 'code'; }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return itemArray.map(function (item) { return ({
        Value: item[valueKey].toString(),
        Text: item.name,
        Object: item,
    }); });
}
exports.default = mapToCatalogItem;
//# sourceMappingURL=mapToCatalogItem.js.map